import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { Spinner } from "@/components/Spinner"

import { trpc } from "../utils/trpc"

export const Route = createFileRoute("/demo/$demoUrl")({
  component: DemoRoute,
  loader: async (ctx) => {
    const { params } = ctx
    const { demoUrl } = params

    const session = await trpc.sessions.createDemo.mutate({ demoUrl })
    if (!session) {
      throw notFound()
    }

    throw redirect({ to: `/$sessionId`, params: { sessionId: session.sessionId } })
  },
  pendingComponent: () => <Spinner position="center" />,
})

function DemoRoute() {
  return <Spinner position="center" />
}
